import React from 'react'
import UsersChartLine from './UsersChartLine'

export default function UsersChartLineDeclined() {
  return <UsersChartLine status={'Declined'} />
}
